import { Controller } from '@hotwired/stimulus'
import 'bootstrap/js/src/collapse'

// Connects to data-controller="bootstrap-collapse"
export default class extends Controller {}
